import { useSelector } from 'react-redux';
import { dataSelector } from '@nextiva/global-store';

export function useGlobalStoreUser() {
  const globalStoreData: {
    user?: {
      nextivaUUID?: string;
      firstName?: string;
      lastName?: string;
      email?: string;
      profileDTO?: { corpAcctNbr?: number };
    };
  } = useSelector(dataSelector);
  return globalStoreData.user;
}
